// eslint-disable-next-line import/no-extraneous-dependencies
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { styled } from "@vitality-ds/system";
import BaseDropdownMenuItemStyles from "./styles/BaseItem.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDropdownMenuItem = styled(RadixDropdown.Item, BaseDropdownMenuItemStyles);